<!-- 中文首页 -->
<template>
  <div>
    <div class="home">
      <div id="banner">
        <div class="banner">
          <img :src="images.a00index1_16">
          <div class="ban_01">
            <div class="ban_04">
              <marquee direction="up" scrollamount="3" style="height:180px;">{{text.home1}}</marquee>
            </div>
          </div>
          <div class="ban_02">
            <div class="ban_03">
              <p>{{text.home2}}</p>
            </div>
            <div class="ban_05">
              <ul class="list03">
                <li>
                  <div class="ban_06">
                    <p>{{text.home3}}{{text.home4}}</p>
                  </div>
                </li>
                <li>
                  <div class="ban_06">
                    <p>{{text.home5}}{{text.home6}}</p>
                  </div>
                </li>
                <li>
                  <div class="ban_06">
                    <p>{{text.home7}}({{text.home8}}</p>
                  </div>
                </li>
                <li>
                  <div class="ban_06">
                    <p>{{text.home9}}{{text.home10}}</p>
                  </div>
                </li>
                <li>
                  <div class="ban_06">
                    <p>{{text.home11}}{{text.home12}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div id="cont">
        <div class="cont">
          <div class="cont_01">
            <div class="cont_02">
              <div class="cont_05">
                <div class="cont_11">
                  <p>{{text.home13}}</p>
                </div>
              </div>
              <div class="cont_06">
                <ul class="list04">
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <img
                          src="../../../assets/img/common/home1.jpg"
                          id="img1"
                          width="54"
                          height="47"
                        >
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/ysjsen">{{text.home14}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home15}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <img
                          src="../../../assets/img/common/home2.jpg"
                          id="img2"
                          width="54"
                          height="47"
                        >
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/kcpen">{{text.home16}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home17}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <a id="A3">
                          <img
                            src="../../../assets/img/common/home3.jpg"
                            id="img3"
                            width="54"
                            height="47"
                          >
                        </a>
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/tszpen">{{text.home18}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home19}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <a id="A4">
                          <img
                            src="../../../assets/img/common/home4.jpg"
                            id="img4"
                            width="54"
                            height="47"
                          >
                        </a>
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/yybjen">{{text.home20}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home21}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <a id="A5">
                          <img
                            src="../../../assets/img/common/home5.jpg"
                            id="img5"
                            width="54"
                            height="47"
                          >
                        </a>
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/hgylen">{{text.home22}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home23}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                  <li>
                    <div style="width: 238px;">
                      <div class="cont_07">
                        <a id="A6">
                          <img
                            src="../../../assets/img/common/home6.gif"
                            id="img6"
                            width="54"
                            height="47"
                          >
                        </a>
                      </div>
                      <div class="cont_08">
                        <div class="cont_09">
                          <router-link to="/producten/gtllen">{{text.home24}}</router-link>
                        </div>
                        <div class="cont_10">
                          <p>{{text.home25}}</p>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="cont_12">
              <div class="cont_03">
                <div class="cont_14">
                  <div class="cont_11">
                    <p>{{text.home26}}</p>
                  </div>
                </div>
                <div class="cont_15">
                  <ul class="list05">
                    <li>
                      <div class="cont_16">
                        <a id="A7">
                          <img
                            src="../../../assets/img/common/home7.jpg"
                            id="img7"
                            width="104"
                            height="53"
                          >
                        </a>
                        <router-link to="/deviceen/lglzen">{{text.home27}}</router-link>
                      </div>
                    </li>
                    <li>
                      <div class="cont_16">
                        <a id="A8">
                          <img
                            src="../../../assets/img/common/home8.jpg"
                            id="img8"
                            width="104"
                            height="53"
                          >
                        </a>
                        <router-link to="/deviceen/gsplen">{{text.home28}}</router-link>
                      </div>
                    </li>
                    <li>
                      <div class="cont_16">
                        <a id="A9">
                          <img
                            src="../../../assets/img/common/home9.jpg"
                            id="img9"
                            width="104"
                            height="53"
                          >
                        </a>
                        <router-link to="/deviceen/jcjen">{{text.home29}}</router-link>
                      </div>
                    </li>
                    <li>
                      <div class="cont_16">
                        <a id="A10">
                          <img
                            src="../../../assets/img/common/home10.jpg"
                            id="img10"
                            width="104"
                            height="53"
                          >
                        </a>
                        <router-link to="/deviceen/dkzgen">{{text.home30}}</router-link>
                      </div>
                    </li>
                  </ul>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
            <div class="cont_13">
              <div class="cont_04">
                <video-player
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                ></video-player>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="cont_17">
            <div class="cont_18">
              <router-link to="/investen">{{text.home31}}&gt;&gt;</router-link>
            </div>
            <div class="cont_19">
              <p>{{text.home32}}</p>
            </div>
            <div class="clear"></div>
          </div>
          <div class="cont_20">
            <div class="marq1">
              <div class="marquee1">
                <vue-seamless-scroll :data="xwlb" :class-option="optionLeft">
                  <ul class="list06">
                    <li v-for="item in xwlb" :key="item.newsId">
                      <div class="ddd">
                        <div class="cont_21">
                          <router-link :to="'/profileen/xwxqen/'+item.newsId">
                            <img :src="item.url" width="168" height="60">
                          </router-link>
                        </div>
                        <p>{{item.title}}</p>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      xwlb: "",
      images: {
        a00index1_16: require("../../../assets/img/en/00index1_16.jpg")
      },
      text: {
        home1:
          "China Material, founded in 2003 in Beijing of China, is a global company who specializes in metals, minerals, carbons, pharmaceutical raw materials and complete plants. As a leading Chinese supplier of the kinds of material, China Material International has been cooperating with many top companies worldwide in the different fields.",
        home2: "CHINA MATERIAL INTERNATIONAL CO., LTD.",
        home3: "Address：",
        home4:
          "O-2307,Building 1,Kuntai International Mansion,Yi No.12,Chaowei street,Chaoyang district,Beijing",
        home5: "Postcode：",
        home6: "100020",
        home7: "Tel：",
        home8: "(010) 5879 7733",
        home9: "Fax：",
        home10: "(010) 5879 7758",
        home11: "Email：",
        home12: "marcobj@marco-cn.com",
        home13: "PRODUCTS",
        home14: "NON-FERROUS METALS",
        home15:
          "Brass.Bronze.Copper.Aluminum.Zinc Ingot.Plate.Foil.Coil Products",
        home16: "MINERALS/RARE EARTHS/IRON",
        home17: "Cr.Mn Ore.Mischmetal.RE Silicide.Si metal.FeSi.Ironalloy",
        home18: "CARBON/METALLURGICAL COAL",
        home19: "Metallurgical Coal.Electrode.Carbon Block.Anode",
        home20: "MEDICINES/HEALTH PRODUCTS",
        home21:
          "Tea Extract.Huperzine A.Chondroitin Sulfate.Glucosamine.Pueraria Extract",
        home22: "CHEMICAL PRODUCTS",
        home23: "Titanium Dioxide.Aluminum Fluoride.Synthetic Cryolite",
        home24: "RAW MATERIALS/STEEL",
        home25: "Mn Lumpy.Mn Briquettes.Mg.Calcium Granule, Cored-wire",
        home26: "EQUIPMENTS AND SOLUTIONS",
        home27: "COMPLE EQ.",
        home28: "NONFER EQ.",
        home29: "PLASTI EQ.",
        home30: "STEEL EQ.",
        home31: "MORE",
        home32: "CASE & NEWS"
      }
    };
  },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 2
      };
    }
  },
  components: {},
  mounted: function() {
    this.getxwlb();
    this.getvideo();
  },
  methods: {
    getvideo() {
      this.$http
        .get("SSM-master/marcoVideo/getById?videoId=1")
        .then(response => {
          this.playerOptions.sources[0].src = response.data.url;
          response => {
            console.log("出错了");
          };
        });
    },
    getxwlb() {
      this.$http.get("SSM-master/marcoNews/getListInEnglish").then(response => {
        this.xwlb = response.data;
        response => {
          console.log("出错了");
        };
      });
    }
  }
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.home {
  #banner {
    background: #4ec9ff;
    width: 100%;
    margin: 0px auto;
    min-width: 1002px;
    overflow: hidden;

    .banner {
      position: relative;
      width: 1002px;
      height: 186px;
      margin: 0px auto;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      .ban_01 {
        position: absolute;
        top: 0;
        left: 0;
        width: 275px;
        height: 186px;
        float: left;
        overflow: hidden;

        .ban_04 {
          width: 246px;
          padding-left: 20px;
          padding-top: 13px;
          color: #fff;
        }
      }

      .ban_02 {
        position: absolute;
        top: 0;
        right: 0;
        width: 225px;
        height: 186px;
        overflow: hidden;

        .ban_03 {
          width: 215px;
          padding-top: 11px;
          font-weight: bold;
          color: #fff;
        }

        .ban_05 {
          width: 215px;
          color: #fff;
          line-height: 18px;

          .ban_06 {
            overflow: hidden;
          }
        }
      }
    }
  }

  #cont {
    width: 100%;
    margin: 0px auto;
    min-width: 1002px;
    overflow: hidden;

    .cont {
      width: 1002px;
      margin: 0px auto;
      overflow: hidden;

      .cont_01 {
        margin-top: 9px;

        .cont_02 {
          width: 485px;
          height: 199px;
          border: solid 1px #d8d8d8;
          float: left;

          .cont_05 {
            width: 485px;
            height: 23px;
            box-sizing: border-box;
            background: #f7f7f7;

            .cont_11 {
              background: url('../../../assets/img/common/00index1_25.jpg') no-repeat 10px center;
              padding-left: 21px;
              border-bottom: solid 1px #d8d8d8;
              height: 22px;
              line-height: 22px;
              color: #ec008c;
              padding-top: 1px;
            }
          }

          .list04 {
            padding-left: 9px;
            overflow: hidden;

            li {
              margin-top: 9px;
              float: left;

              .cont_07 {
                float: left;
              }

              .cont_08 {
                float: left;
                padding-left: 4px;
                line-height: 16px;

                .cont_09 {
                  overflow: hidden;
                  height: 20px;
                  width: 160px;

                  a {
                    color: #5d5d5d;
                    font-weight: bold;
                    word-break: break-all;
                    overflow: hidden;
                    height: 15px;
                  }
                }

                .cont_10 {
                  width: 170px;
                  word-break: break-all;
                  overflow: hidden;
                  height: 30px;
                }
              }
            }
          }
        }

        .cont_12 {
          float: left;

          .cont_03 {
            width: 249px;
            height: 199px;
            border: solid 1px #d8d8d8;
            margin-left: 5px;

            .cont_14 {
              // background: url(../../../images/00index1_22.jpg) repeat-x;
              width: 249px;
              height: 23px;
              margin-bottom: 9px;

              .cont_11 {
                background: url('../../../assets/img/common/00index1_25.jpg') no-repeat 10px center;
                padding-left: 21px;
                border-bottom: solid 1px #d8d8d8;
                height: 22px;
                line-height: 22px;
                color: #ec008c;
                padding-top: 1px;
              }
            }

            .list05 {
              padding-left: 3px;
              padding-top: 0px;

              li {
                padding: 0 6px;
                float: left;

                .cont_16 {
                  text-align: center;

                  a {
                    color: #5d5d5d;
                    display: block;

                    img {
                      border: solid 3px #d8d8d8;
                    }
                  }
                }
              }
            }
          }
        }

        .cont_13 {
          float: left;

          .cont_04 {
            width: 249px;
            height: 199px;
            border: solid 1px #d8d8d8;
            margin-left: 5px;

            .video-player {
              width: 100%;
              height: 100%;
            }

            .vjs-custom-skin > .video-js {
              height: 100%;
            }
          }
        }
      }

      .cont_17 {
        box-sizing: border-box;
        border: 1px solid #ccc;
        background: #f7f7f7;
        width: 1002px;
        height: 30px;
        margin-top: 3px;

        .cont_18 {
          float: right;
          width: 45px;
          padding-right: 10px;
          line-height: 30px;

          a {
            color: #5d5d5d;
          }
        }

        .cont_19 {
          float: left;
          background: url('../../../assets/img/common/00index1_25.jpg') no-repeat 10px center;
          color: #ec008c;
          width: 100px;
          padding-left: 21px;
          line-height: 30px;
        }
      }

      .cont_20 {
        width: 1000px;
        margin: 0 auto;
        text-align: center;

        .marquee1 {
          width: 1000px;
          height: 100px;
          overflow: hidden;

          .list06 {
            width: 1000px;

            li {
              padding: 4px 11px;
              float: left;

              .ddd {
                // background: url(../../../images/00index1_37.jpg) no-repeat;
                width: 173px;
                height: 75px;
                text-align: center;
                padding-top: 5px;
                padding-left: 5px;
                overflow: hidden;

                img {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/en/home/home.vue